'use client';

import {useEffect} from 'react';

/**
 * WDYR Provider - инициализирует Why Did You Render на клиенте
 *
 * Этот компонент должен быть добавлен в root layout для активации
 * отслеживания ненужных ререндеров в development режиме.
 */
export function WdyrProvider() {
  useEffect(() => {
    // Инициализируем wdyr только один раз при монтировании
    if (process.env.NODE_ENV === 'development') {
      // Динамический импорт для загрузки wdyr на клиенте
      import('./wdyr').catch(err => {
        console.error('Failed to load WDYR:', err);
      });
    }
  }, []);

  // Этот компонент не рендерит ничего
  return null;
}
